var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapSymbolEscapeRoute = function SvgFiremapSymbolEscapeRoute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M11.214 9v1.37H8.09v.941h2.833v1.37H8.09v.95h3.21V15H6.31V9zm6.476 6h-2.02l-.796-1.618h-.941V15h-1.78V9h2.798c1.61 0 2.534.77 2.534 2.131 0 .89-.36 1.54-1.01 1.909zm-3.757-4.63v1.643h1.018c.531 0 .84-.291.84-.83 0-.522-.309-.813-.84-.813z",
    clipRule: "evenodd"
  })));
};
export default SvgFiremapSymbolEscapeRoute;